module.exports = __webpack_public_path__ + "static/media/titulo.7f90e314.svg";